module.exports = __webpack_public_path__ + "static/media/carousel5.66688437.png";